<template>
	<div class="reviews">
		<h2 class="reviews__lead">More Raving Reviews!</h2>

		<ul class="reviews__list">
			<li
				v-for="review in reviews"
				:key="review.id"
				class="reviews__review"
			>
				<div class="reviews__avatar">
					<img
						v-if="review.avatar"
						:src="review.avatar"
						:alt="review.name"
					/>
					<span v-else>{{ reviewerInitials(review.name) }}</span>
				</div>
				<div class="reviews__description">
					<span class="reviews__name">{{ review.name }}</span>
					<span class="reviews__verified">
						<i class="fa fa-check-circle"></i>
						<span>Verified buyer</span>
					</span>
					<div
						class="reviews__rating"
						:aria-label="`Product rating ${review.rating} out of 5`"
					>
						<i
							v-for="(_, index) in 5"
							:key="index"
							class="fa fa-star"
							:class="{ filled: index < review.rating }"
							role="presentation"
							aria-hidden="true"
						></i>
					</div>

					<span class="reviews__comment">{{ review.comment }}</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		reviews: {
			type: Array,
			required: true,
		},
	},
	methods: {
		reviewerInitials(name) {
			const names = name.split(' ');
			const firstName = names[0].substring(0, 1);
			if (names.length === 1) {
				return `${firstName}`;
			}

			const lastName = names[names.length - 1].substring(0, 1);
			return `${firstName}${lastName}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.reviews {
	margin-top: var(--size-xl);

	&__lead {
		display: none;
		font-size: var(--size-md);
		margin-bottom: var(--size-md);

		@media screen and (max-width: 992px) {
			display: block;
		}
	}
	&__list {
		display: flex;
		flex-direction: column;
		padding: 0;
		font-size: var(--size-base);
	}

	&__review {
		display: flex;
		gap: var(--size-base);
		padding: var(--size-xl) 0;
		border-bottom: 1px solid var(--gray-300);

		&:first-of-type {
			border-top: 1px solid var(--gray-300);
		}
	}

	&__rating {
		display: flex;
		gap: var(--size-xs);
		margin-bottom: var(--size-sm);

		> i {
			color: var(--gray-400);

			&.filled {
				color: #e0812c;
			}
		}
	}

	&__verified {
		display: flex;
		gap: var(--size-xs);
		align-items: center;
		margin-bottom: var(--size-sm);

		> i {
			color: var(--green-500);
		}

		> span {
			color: var(--gray-500);
		}
	}

	&__avatar {
		width: var(--size-xxl);
		height: var(--size-xxl);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border: 1px solid var(--gray-300);
		flex: none;

		> span {
			font-size: var(--size-md);
			letter-spacing: 0.05em;
			line-height: 1;
			text-transform: uppercase;
		}

		> img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	&__description {
		display: flex;
		flex-direction: column;
	}
}
</style>
